<section class="page">

  <header class="page-header">

    <div>

      <h1>Automation</h1>

      <p>Trigger-based rules with conditions and multi-action workflows.</p>

    </div>

    <mat-form-field appearance="outline">

      <mat-label>Project</mat-label>

      <mat-select [value]="selectedProjectId()" (selectionChange)="onProjectChange($event.value)">

        @for (p of projects(); track p.id) {

          <mat-option [value]="p.id">{{ p.name }}</mat-option>

        }

      </mat-select>

    </mat-form-field>

  </header>



  @if (error()) { <div class="error">{{ error() }}</div> }



  <div class="create-card">

    <h2>New rule</h2>

    <div class="form-section">

      <h3>Basics</h3>

      <div class="form-row">

        <mat-form-field appearance="outline" class="grow"><mat-label>Name</mat-label><input matInput [(ngModel)]="ruleName"></mat-form-field>

        <mat-form-field appearance="outline" class="grow"><mat-label>Description</mat-label><input matInput [(ngModel)]="ruleDescription"></mat-form-field>

      </div>

    </div>



    <mat-divider></mat-divider>



    <div class="form-section">

      <h3>When (trigger)</h3>

      <div class="form-row">

        <mat-form-field appearance="outline">

          <mat-label>Trigger</mat-label>

          <mat-select [(ngModel)]="triggerType" (ngModelChange)="onTriggerChange()">

            @for (t of triggerOptions(); track t.value) { <mat-option [value]="t.value">{{ t.label }}</mat-option> }

          </mat-select>

        </mat-form-field>

      </div>

    </div>



    <mat-divider></mat-divider>



    <div class="form-section">

      <h3>Conditions</h3>

      <p class="hint">Optional field / operator / value rows serialized to ConditionsJson.</p>

      @for (c of conditions; track $index) {

        <div class="form-row condition-row">

          <mat-form-field appearance="outline">

            <mat-label>Field</mat-label>

            <mat-select [(ngModel)]="c.field">

              @for (f of conditionFields(); track f.value) { <mat-option [value]="f.value">{{ f.label }}</mat-option> }

            </mat-select>

          </mat-form-field>

          <mat-form-field appearance="outline">

            <mat-label>Operator</mat-label>

            <mat-select [(ngModel)]="c.op">

              @for (o of conditionOps(); track o.value) { <mat-option [value]="o.value">{{ o.label }}</mat-option> }

            </mat-select>

          </mat-form-field>

          <mat-form-field appearance="outline" class="grow"><mat-label>Value</mat-label><input matInput [(ngModel)]="c.value"></mat-form-field>

          <button mat-icon-button type="button" color="warn" (click)="removeCondition($index)"><mat-icon>remove_circle</mat-icon></button>

        </div>

      }

      <button mat-stroked-button type="button" (click)="addCondition()"><mat-icon>add</mat-icon> Add condition</button>

    </div>



    <mat-divider></mat-divider>



    <div class="form-section">

      <h3>Then (action)</h3>

      <div class="form-row">

        <mat-form-field appearance="outline">

          <mat-label>Action type</mat-label>

          <mat-select [(ngModel)]="actionType">

            @for (a of actionOptions(); track a.value) { <mat-option [value]="a.value">{{ a.label }}</mat-option> }

          </mat-select>

        </mat-form-field>

      </div>

      <div class="form-row action-config">

        @switch (actionType) {

          @case ('AssignEmployee') {

            <mat-form-field appearance="outline" class="grow"><mat-label>Employee ID</mat-label><input matInput [(ngModel)]="assignEmployeeId"></mat-form-field>

          }

          @case ('NotifyUser') {

            <mat-form-field appearance="outline" class="grow"><mat-label>User ID</mat-label><input matInput [(ngModel)]="notifyUserId"></mat-form-field>

          }

          @case ('SetField') {

            <mat-form-field appearance="outline"><mat-label>Field key</mat-label><input matInput [(ngModel)]="actionFieldKey"></mat-form-field>

            <mat-form-field appearance="outline" class="grow"><mat-label>Value</mat-label><input matInput [(ngModel)]="actionFieldValue"></mat-form-field>

          }

          @case ('ChangeStatus') {

            <mat-form-field appearance="outline" class="grow"><mat-label>New status</mat-label><input matInput [(ngModel)]="actionStatus" placeholder="Done"></mat-form-field>

          }

          @case ('MoveSprint') {

            <mat-form-field appearance="outline" class="grow"><mat-label>Sprint ID</mat-label><input matInput [(ngModel)]="actionSprintId"></mat-form-field>

          }

          @case ('SendEmail') {

            <mat-form-field appearance="outline" class="grow"><mat-label>Email</mat-label><input matInput [(ngModel)]="actionEmail"></mat-form-field>

          }

          @case ('Webhook') {

            <mat-form-field appearance="outline" class="grow"><mat-label>Webhook URL</mat-label><input matInput [(ngModel)]="actionWebhookUrl"></mat-form-field>

          }

          @case ('ScheduleReminder') {

            <mat-form-field appearance="outline"><mat-label>Hours before</mat-label><input matInput type="number" [(ngModel)]="actionReminderHours"></mat-form-field>

          }

        }

        <button mat-flat-button color="primary" type="button" [disabled]="saving()" (click)="createRule()">

          {{ saving() ? 'Creating…' : 'Create rule' }}

        </button>

      </div>

    </div>

  </div>



  @if (loading()) { <div class="loading"><mat-spinner diameter="36"></mat-spinner></div> }



  <table mat-table [dataSource]="rules()" class="full">

    <ng-container matColumnDef="name"><th mat-header-cell *matHeaderCellDef>Rule</th><td mat-cell *matCellDef="let r">{{ r.name }}</td></ng-container>

    <ng-container matColumnDef="trigger"><th mat-header-cell *matHeaderCellDef>Trigger</th><td mat-cell *matCellDef="let r">{{ triggerLabel(r) }}</td></ng-container>

    <ng-container matColumnDef="action"><th mat-header-cell *matHeaderCellDef>Action</th><td mat-cell *matCellDef="let r">{{ actionLabel(r) }}</td></ng-container>

    <ng-container matColumnDef="enabled">

      <th mat-header-cell *matHeaderCellDef>Enabled</th>

      <td mat-cell *matCellDef="let r">

        <mat-slide-toggle [checked]="r.isEnabled" (change)="toggleRule(r)"></mat-slide-toggle>

      </td>

    </ng-container>

    <ng-container matColumnDef="actions">

      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let r">

        <button mat-icon-button color="warn" type="button" (click)="deleteRule(r)"><mat-icon>delete</mat-icon></button>

      </td>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>

    <tr mat-row *matRowDef="let row; columns: columns"></tr>

  </table>

  @if (!loading() && !rules().length) { <p class="muted">No automation rules yet.</p> }



  <h2 class="section-title">Executions</h2>

  <table mat-table [dataSource]="executions()" class="full executions-table">

    <ng-container matColumnDef="ruleName"><th mat-header-cell *matHeaderCellDef>Rule</th><td mat-cell *matCellDef="let e">{{ e.ruleName }}</td></ng-container>

    <ng-container matColumnDef="triggerTypeLabel"><th mat-header-cell *matHeaderCellDef>Trigger</th><td mat-cell *matCellDef="let e">{{ e.triggerTypeLabel }}</td></ng-container>

    <ng-container matColumnDef="actionType"><th mat-header-cell *matHeaderCellDef>Action</th><td mat-cell *matCellDef="let e">{{ e.actionType || '—' }}</td></ng-container>

    <ng-container matColumnDef="success">

      <th mat-header-cell *matHeaderCellDef>Success</th>

      <td mat-cell *matCellDef="let e">

        <span [class.success]="e.success" [class.failure]="!e.success">{{ e.success ? 'Yes' : 'No' }}</span>

      </td>

    </ng-container>

    <ng-container matColumnDef="message"><th mat-header-cell *matHeaderCellDef>Message</th><td mat-cell *matCellDef="let e">{{ e.message || '—' }}</td></ng-container>

    <ng-container matColumnDef="occurredAt"><th mat-header-cell *matHeaderCellDef>Occurred</th><td mat-cell *matCellDef="let e">{{ e.occurredAt | date:'short' }}</td></ng-container>

    <tr mat-header-row *matHeaderRowDef="executionColumns"></tr>

    <tr mat-row *matRowDef="let row; columns: executionColumns"></tr>

  </table>

  @if (!executions().length) { <p class="muted">No recent execution logs.</p> }

</section>


